var render = function render(){var _vm=this,_c=_vm._self._c;return _c('StandardChart',{attrs:{"input":_vm.chartData,"showDownload":true,"showTotal":true,"chartType":"bar","max-width":"100%"}})
}
var staticRenderFns = []

export { render, staticRenderFns }